"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VisibilityStatus;
(function (VisibilityStatus) {
    VisibilityStatus["Visible"] = "VISIBLE";
    VisibilityStatus["Disabled"] = "DISABLED";
    VisibilityStatus["DisabledFoldable"] = "DISABLED_FOLDABLE";
    VisibilityStatus["Hidden"] = "HIDDEN";
    /**
     * Unavailable status is a visible status but not available for any users
     */
    VisibilityStatus["Unavailable"] = "UNAVAILABLE";
})(VisibilityStatus || (VisibilityStatus = {}));
exports.default = VisibilityStatus;
